import React, {lazy, Suspense, useState} from 'react';
import "./Hiw.scss";

const Hiw = (props) => {
  const [attributes, setAttributes] = useState(props)
  let ComponentLazy = null;

  if(attributes.page === "moka") { ComponentLazy = lazy(() => import("./Content/Moka"));}

  return (
    <div className="Hiw col-xs-12" id='Hiw'>
      <Suspense fallback={<div>Loading...</div>}>
        <ComponentLazy attributes={props}/>
      </Suspense>
    </div>
  )
}
export default Hiw;
